import React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

export default class SlidePainel extends React.Component {
    render() {
        const images = [
            {
                original: process.env.PUBLIC_URL + '/slides/sl1.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/sl1.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/sl2.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/sl2.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/sl3.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/sl3.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/sl4.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/sl4.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/sl5.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/sl5.jpg',
            }
        ]
        return (

                <>


                <section className="page-section portfolio" id="painel">
                    <div className="container">

                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Painel do seu Cliente</h2>

                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon">
                        <i className="fa fa-star"></i>
                        </div>
                        <div className="divider-custom-line"></div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        <ImageGallery items={images} autoPlay={true} />
                        </div>
                        <div className="col-md-6 p-3">
                        <h2>O que vamos encontrar aqui?</h2>
                        <p>No painel do usuário, encontramos todas as ferramentas necessárias para que ele possa encontrar os pedidos que realizou, os endereços cadastrados por ele como também seus dados pessoais.</p>
                        <ol className="ml-3">
                            <li>Dados pessoais do usuário (pessoa física ou pessoa jurídica)</li>
                            <li>Área de Pedidos realizados</li>
                            <li>Área de Endereços do usuário</li>
                        </ol>
                        <h4>Caso o usuário cadastrado seja o dono da loja, vai aparecer também um botão vermelho que leva até a área administrativa da loja.</h4>
                        </div>
                    </div>

                    </div>

                </section>

                </>

        );
    }
}